import { request as apiRequest } from '@pocket/web-utilities/request'
import { requestWithAuth as apiRequestWithAuth } from '@pocket/web-utilities/request'
import { CONSUMER_KEY } from '../constants'

export const request = (options) => {
  return apiRequest(CONSUMER_KEY, options)
}

export const requestWithAuth = (options) => {
  return apiRequestWithAuth(CONSUMER_KEY, options)
}
